import { Component, OnInit } from '@angular/core';
import { ProcessosFiltrados, ProcessosFiltradosFiltro } from '@app/models/relatorios-processos-filtrados';
import { IdDescricao } from '@app/models/util/id-descricao';
import { ConsultasService } from '@app/services/consultas.service';
import { RelatorioService } from '@app/services/relatorio.service';
import { UtilitarioService } from '@app/services/utilitario.service';
import { ToastrService } from 'ngx-toastr';
import debounce from '@app/utils/debounce';

@Component({
  selector: 'app-relprocessosfiltrados',
  templateUrl: './relatorio-processos-filtrados.component.html'
})

export class RelatorioProcessosFiltradosComponent implements OnInit {
  
  listaNaturezaDeAcao: IdDescricao[] = [];
  listaEstadoProcesso: IdDescricao[] = [];
  listaUnidades: IdDescricao[] = [];
  listaTipoAcao: IdDescricao[] = [];
  listaCidades: IdDescricao[] = [];
  listaAdvogados: IdDescricao[] = [];
  listaEncaminhador: any[] = [];

  _debounce: any;
  _pesquisa: any;

  filtros: ProcessosFiltradosFiltro = new ProcessosFiltradosFiltro();
  listaProcessos: ProcessosFiltrados[] = [];
  quantidadeProcessos: number = 0;
  dataRelatorio: Date;
  pesquisando: boolean = false;
  
mostraDataCriacao:boolean = true;
  mostraCidade: boolean = true;
  mostraEstado: boolean = true;
  mostraAdvogado: boolean = true;
  mostraUnidade: boolean = true;
  mostraTipoAcao: boolean = true;
  mostraNaturezaAcao: boolean = true;
  mostraEncaminhador: boolean = true;
  
  nomeParticipanteRelatorio: string = "";
  
  constructor(
    private _consultasService: ConsultasService,
    private _relatorioService: RelatorioService,
     private _toastrService: ToastrService
  ) { }

  ngOnInit(): void {
    this._consultasService.consultar('NATUREZADEACAO').toPromise().then(data => this.listaNaturezaDeAcao = data);
    this._consultasService.consultar('ESTADODOPROCESSO').toPromise().then(data => this.listaEstadoProcesso = data);
    this._consultasService.consultar('UNIDADE_S_RATEIO').toPromise().then((data) => this.listaUnidades = data);
    this._consultasService.consultar('TIPODEACAO').toPromise().then(data => this.listaTipoAcao = data);
    this._consultasService.consultar('CIDADE').toPromise().then(data => this.listaCidades = data);
    this._consultasService.consultar('ADVOGADO').toPromise().then(data => this.listaAdvogados = data);
  }

  pesquisar(){
    this.pesquisando = true;
    this.dataRelatorio = new Date();

    if(!this.liberaPesquisa())
      return;

    this._relatorioService.processosfiltrados(this.filtros).subscribe(
      (data) => {
        this.listaProcessos = data;
        this.quantidadeProcessos = this.listaProcessos.length;
        this.adequaTabela(this.listaProcessos);
        this.pesquisando = false;
      },
      () => {
        this.pesquisando = false;
      });
      this._relatorioService.processosfiltrados(this.filtros).toPromise().then(
      data => {
        this.listaProcessos = data;
        this.quantidadeProcessos = this.listaProcessos.length;
        this.adequaTabela(this.listaProcessos);
        this.pesquisando = false;
      },
      error => {
        this._toastrService.warning("Realize a pesquisa novamente");
        this.pesquisando = false;
      }
    );
  }

  liberaPesquisa(){
    if(!this.filtros.AdvogadoId &&
      !this.filtros.CidadeId &&
      !this.filtros.EncaminhadoPor &&
      !this.filtros.EstadoDoProcessoId &&
      !this.filtros.NaturezaDeAcaoId &&
      !this.filtros.ParteContraria &&
      !this.filtros.TipoDeAcaoId &&
      !this.filtros.UnidadeId      
      )
      {
        this.pesquisando = false;
        return false;
      }
      
      return true;
  }

  adequaTabela(lista: ProcessosFiltrados[]){
    this.mostraCidade = true;
    this.mostraEstado = true;
    this.mostraAdvogado = true;
    this.mostraUnidade = true;
    this.mostraTipoAcao = true;
    this.mostraNaturezaAcao = true;
    this.mostraEncaminhador = true;
    this.mostraDataCriacao = true;
   
    if(!lista.find(x => x.CidadeCliente))
      this.mostraCidade = false;
    if(!lista.find(x => x.EstadoDoProcesso))
      this.mostraEstado = false;
    if(!lista.find(x => x.NomeAdvogado))
      this.mostraAdvogado = false;
    if(!lista.find(x => x.Unidade))
      this.mostraUnidade = false;
    if(!lista.find(x => x.TipoDeAcao))
      this.mostraTipoAcao = false;
    if(!lista.find(x => x.NaturezaDeAcao))
      this.mostraNaturezaAcao = false;
    if(!lista.find(x => x.NomeEncaminhador))
      this.mostraEncaminhador = false;

    

  }

  public imprimir() {
    let tituloRelatorio: string = "Relatório processos filtrados";
    let conteudo = document.getElementById("relatorioProcessosFiltrados").innerHTML;
    UtilitarioService.imprimirHTML(conteudo, tituloRelatorio, this.montaImpressaoFiltros());
  }

  private montaImpressaoFiltros(){
    let objetoFiltros = new Map<string, string>();

    adicionaMapValido('Emitido em', this.dataRelatorio.toLocaleString());
  
    obtemDescricaoAdicionaMap('Tipo de Ação', this.listaTipoAcao, Number(this.filtros.TipoDeAcaoId));
    obtemDescricaoAdicionaMap('Natureza de Ação', this.listaNaturezaDeAcao, Number(this.filtros.NaturezaDeAcaoId));
    obtemDescricaoAdicionaMap('Estado do Processo', this.listaEstadoProcesso, Number(this.filtros.EstadoDoProcessoId));
    obtemDescricaoAdicionaMap('Advogado', this.listaAdvogados, Number(this.filtros.AdvogadoId));
    obtemDescricaoAdicionaMap('Cidade do Cliente', this.listaCidades, Number(this.filtros.CidadeId));
    obtemDescricaoAdicionaMap('Unidade', this.listaUnidades, Number(this.filtros.UnidadeId));
    adicionaMapValido('Participante', this.nomeParticipanteRelatorio);
    adicionaMapValido("Parte Contrária", this.filtros.ParteContraria);
   
    
    function obtemDescricaoAdicionaMap(chave: string, listaItens: IdDescricao[], idItem: number){
      if(idItem){
        let valor = listaItens.find(x => x.Id === idItem).Descricao;
        objetoFiltros.set(chave, valor);
      } 
    }
    
    function adicionaMapValido(chave: string, valor: any){
      if(valor){
        objetoFiltros.set(chave, valor.toString());
      }
    }

    let stringHtml = '';

    objetoFiltros.forEach((valor, chave) => {
      stringHtml += `<tr><td>${chave}</td><td>${valor}</td></tr>`;
    })
    return stringHtml;
  }

}
